module.exports = __webpack_public_path__ + "static/media/iso45001.8bee3ec4.png";